import request from '@/utils/request'

// 查询下单检查项列表
export function apiScpOrderCheckItemList (query) {
  return request({
    url: '/scp/scpOrderCheckItem/list',
    method: 'get',
    params: query
  })
}

// 查询下单检查项日志列表
export function apiGetCheckItemLog (query) {
  return request({
    url: '/scp/scpOrderCheckItem/getCheckItemLog',
    method: 'get',
    params: query
  })
}

// 导出下单检查项列表
export function apiScpOrderCheckItemExport (data) {
  return request({
    url: '/scp/scpOrderCheckItem/v2/export',
    method: 'post',
    data: data
  })
}

// 新增下单检查项
export function apiScpOrderCheckItemAdd (data) {
  return request({
    url: '/scp/scpOrderCheckItem',
    method: 'post',
    data: data
  })
}

// 修改下单检查项
export function apiScpOrderCheckItemUpdate (data) {
  return request({
    url: '/scp/scpOrderCheckItem',
    method: 'put',
    data: data
  })
}

// 删除下单检查项
export function apiScpOrderCheckItemDel (id) {
  return request({
    url: '/scp/scpOrderCheckItem/' + id,
    method: 'delete'
  })
}
